import { icon } from "../../common/common";

export interface MessageWarnings {
  message: string;
  textClass: string;
  bgClass: string;
  icon: any;
}

interface AllWarning {
  NEITHER_FOLLOWING: MessageWarnings;
  USER_IS_FOLLOWING: MessageWarnings;
  LOGGED_IN_USER_IS_FOLLOWING: MessageWarnings;
  USER_DEFAULT: MessageWarnings;
  STORE_DEFAULT: MessageWarnings;
  LIMIT_MESSAGE_REACHED: MessageWarnings;
  JUST_FOLLLOWED: MessageWarnings;
  ADMIN_IS_BLOCKED: MessageWarnings;
  ADMIN_IS_BLOCKED_BY_STORE: MessageWarnings;
  ACCOUNT_DELETED: MessageWarnings;
  STORE_ACCOUNT_DELETED: MessageWarnings; 
}

export const messageWarnings: AllWarning = {
  NEITHER_FOLLOWING: {
    message: "You can't message this user until they follow you",
    textClass: "text-primary",
    bgClass: "bg-lemon-chiffon",
    icon: icon({ iconName: "warning", iconColor: "icon-modern-gray" }),
  },
  JUST_FOLLLOWED: {
    message: "You're now following [FullName]",
    textClass: "text-primary",
    bgClass: "bg-anti-flash-white",
    icon: icon({ iconName: "info", iconColor: "icon-modern-gray" }),
  },
  LOGGED_IN_USER_IS_FOLLOWING: {
    message: "Waiting for them to follow back to message",
    textClass: "text-primary",
    bgClass: "bg-anti-flash-white",
    icon: icon({ iconName: "info", iconColor: "icon-modern-gray" }),
  },
  USER_IS_FOLLOWING: {
    message: "Follow back to message this user",
    textClass: "text-primary",
    bgClass: "bg-anti-flash-white",
    icon: icon({ iconName: "info", iconColor: "icon-modern-gray" }),
  },
  USER_DEFAULT: {
    message: "Messages are encrypted. Only you and the recipient can read them.",
    textClass: "text-primary",
    bgClass: "bg-anti-flash-white",
    icon: icon({ iconName: "lock", iconColor: "icon-modern-gray" }),
  },
  STORE_DEFAULT: {
    message: "You can send up to 3 messages until this store accepts your request",
    textClass: "text-primary",
    bgClass: "bg-anti-flash-white",
    icon: icon({ iconName: "info", iconColor: "icon-modern-gray" }),
  },
  LIMIT_MESSAGE_REACHED: {
    message: "Message limit reached. You cannot send more messages to this store.",
    textClass: "text-true-white",
    bgClass: "bg-crimson",
    icon: icon({ iconName: "info", iconColor: "icon-true-white" }),
  },
  ADMIN_IS_BLOCKED: {
    message: "Only friends can send messages to each other",
    textClass: "text-primary",
    bgClass: "bg-anti-flash-white",
    icon: icon({ iconName: "info", iconColor: "icon-modern-gray" }),
  },
  ADMIN_IS_BLOCKED_BY_STORE: {
    message: "You have been blocked by this store. You cannot send messages.",
    textClass: "text-true-white",
    bgClass: "bg-crimson",
    icon: icon({ iconName: "info", iconColor: "icon-true-white" }),
  },
  ACCOUNT_DELETED: {
    message: "This account has been deleted",
    textClass: "text-primary",
    bgClass: "bg-anti-flash-white",
    icon: icon({ iconName: "info", iconColor: "icon-modern-gray" }),
  },
  STORE_ACCOUNT_DELETED: {
    message: "This store account has been deleted",
    textClass: "text-primary",
    bgClass: "bg-anti-flash-white",
    icon: icon({ iconName: "info", iconColor: "icon-modern-gray" }),
  }
};
